import {mapState} from "vuex";
import Vue from "vue";

export default {
    props: {
        enableDynamicStack: {
            type: Boolean,
            default: false
        },
        id: [String, Number],
        heightPx: {
            type: [String, Number],
            default: 250
        }
    },
    data() {
        return {
            folded: false
        }
    },
    computed: {
        ...mapState({
            needExportChartId: state => state.customizedDiagram.needExportChartId,
            exportChartData: state => state.customizedDiagram.exportChartData,
        }),
        isNotCurrent() {
            return this.needExportChartId && this.needExportChartId !== this.id;
        },
        dynamicStackIcon() {
            if (this.id) {
                if (this.isNotCurrent) {
                    return 'box-arrow-in-down';
                } else if (this.needExportChartId) {
                    return 'x-lg';
                } else {
                    return 'box-arrow-up';
                }
            }
            return null;
        },
        $_exportData() {
            return {};
        },
        heightStyle() {
            let h = this.folded ? 0 : this.heightPx;
            return `height: ${h}px !important;`;
        },
    },
    mounted() {
        this.addButtonToDom();
    },
    methods: {
        addButtonToDom() {
            let el = document.getElementById("lineChart");
            if (el) {
                if (this.enableDynamicStack && this.dynamicStackIcon != null) {
                    let h = this.$createElement;
                    let extend = Vue.extend({
                        render: () => {
                            return h('div',
                                {
                                    class: 'd-flex flex-row position-absolute top right ',
                                    style: this.folded ? 'top: -20px !important;' : ''
                                },
                                [
                                    h('b-button', {
                                            props: {
                                                pill: true,
                                                variant: 'light'
                                            },
                                            on: {
                                                click: () => this.$_triggerFoldChart(),
                                            }
                                        },
                                        [h('i', {class: 'fa-solid ' + (this.folded ? 'fa-arrows-down-to-line' : 'fa-arrows-up-to-line')})]),
                                    h('b-avatar', {
                                        props: {
                                            variant: this.isNotCurrent ? 'success' : 'light',
                                            size: '1.8rem',
                                            button: true,
                                            icon: this.dynamicStackIcon
                                        },
                                        class: 'ml-1',
                                        on: {
                                            click: () => this.handleClick(),
                                        }
                                    })
                                ])
                        }
                    });
                    let temp = new extend();
                    temp.$mount(el);
                }
            }
        },
        handleClick() {
            if (!this.needExportChartId) {
                this.$store.commit("customizedDiagram/selectChart", {
                    id: this.id,
                    data: this.$_exportData,
                });
            } else {
                if (this.needExportChartId !== this.id) {
                    this.$_stackIntoLocale();
                    this.$emit('stacked', this.needExportChartId);
                }
                this.$store.commit('customizedDiagram/resetExportChartId');
            }
        },
        $_stackIntoLocale() {
            //need overwrite
        },
        $_triggerFoldChart() {
            this.folded = !this.folded;
        },
    },
    beforeDestroy() {
        this.$emit('canceled', this.id);
    }
}